import { withStyles } from "@material-ui/core/styles";
import Column from "./Column";
import styles from "./styles";

export default withStyles(styles)(Column);
